import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';
import {
  Button,
  ButtonGroup
} from '@material-ui/core';

import DashboardCards from 'components/Dashboard/DashboardCards';
import DashboardCharts from 'components/Dashboard/DashboardCharts';
//import DashboardTables from 'components/Dashboard/DashboardTables';
import ScanProductsModal from 'components/Dashboard/ScanProductsModal';

import { admin, standard } from 'variables/userAccountTypes';

const mapStateToProps = (state) => ({
  activeUserType: state.activeUserType,
  salesOrders: state.salesOrders,
  purchaseOrders: state.purchaseOrders.filter(purchaseOrder => purchaseOrder.payments.length > 0),
  returnOrders: state.returnOrders,
  products: state.products,
  expenses: state.expenses,
  vendors: state.vendors,
  user: state.user
});

const Dashboard = (props) => {
  const navigate = useNavigate();

  const [openScanModal, setOpenScanModal] = useState(false);

  const navigateToComponent = (destination) => {
    navigate(`/app/${destination}`, { replace: true });
  };

  const handleScanModalClose = () => {
    setOpenScanModal(false)
  };  

  return (
    <div>
      <Helmet>
        <title>Dashboard | Duot One</title>
      </Helmet>
      <ButtonGroup color="primary" aria-label="text primary button group">
        { !(props.activeUserType === admin) ?
        <Button
          onClick={() => navigateToComponent("quickSale")}
        >
          Quick Sale
        </Button> : null }
        <Button
          onClick={() => navigateToComponent("salesOrders")}
        >
          Sales Orders
        </Button>
        <Button
          onClick={() => navigateToComponent("products")}
        >
          Products
        </Button>
        { !(props.activeUserType === standard) ?
        <Button
          onClick={() => navigateToComponent("purchaseOrders")}
        >
          Purchase Orders
        </Button> : null }
        <Button
          onClick={() => navigateToComponent("expenses")}
        >
          Expenses
        </Button>
        { !(props.activeUserType === standard) ?
        <Button
          onClick={() => navigateToComponent("accounts")}
        >
          Accounts
        </Button> : null }
        <Button
          color="primary"
          variant="contained"
          onClick={() => setOpenScanModal(true)}
        >
          Scan Product
        </Button>
      </ButtonGroup>      
      <DashboardCards
        salesOrders={props.salesOrders}
        purchaseOrders={props.purchaseOrders}
        returnOrders={props.returnOrders}
        expenses={props.expenses}
      />
      <DashboardCharts
        salesOrders={props.salesOrders}
        expenses={props.expenses}
      />
      {/* <DashboardTables
        salesOrders={props.salesOrders}
        vendors={props.vendors}
      /> */}
      { openScanModal ?
      <ScanProductsModal
        open={openScanModal}
        products={props.products}
        closeModal={handleScanModalClose}
      /> : null }
    </div>
  )
};

export default connect (mapStateToProps) (Dashboard);